import { StatTile } from '@/components/ui/stat-tile';
import { translate } from "../../../../utils/Common";

// Total de paquetes en las plataformas. El gráfico de tarta que le daba nombre
// lleva comentado desde hace tiempo: esto es una cifra, y una cifra es un tile.
const GraphPackagesInPlatforms = ({ cantPackagesInLocker }) => (
  <StatTile
    loading={cantPackagesInLocker === null}
    value={(cantPackagesInLocker || []).reduce((n, p) => n + (p.CantPaquetes || 0), 0)}
    label={translate("dashboard.home.packages_platforms.title")}
    info={
      translate("dashboard.home.packages_platforms.info_1") +
      translate("dashboard.home.packages_platforms.info_2")
    }
  />
);

export default GraphPackagesInPlatforms;
